import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useAuthenticated } from "../../authn";
import { AsyncResult } from "../../shared";
import { WorkspaceContext } from "./WorkspaceContext";

/*
    Currently each user has only one workspace, so we can store the workspaceId in the context.
    If in the future we want to support multiple workspaces per user, 
    we should use a url parameter to identify the workspace instead.
*/

interface WorkspaceProviderProps {
  children: React.ReactNode;
}

export function WorkspaceProvider({ children }: WorkspaceProviderProps) {
  const auth = useAuthenticated();

  const ownWorkspace = useQuery({
    queryFn: async () => {
      // First try to get existing workspace
      const workspace = await api.getOwnWorkspace();

      // If no workspace exists, provision one
      if (workspace === null) {
        return await api.provisionWorkspace();
      }

      return workspace;
    },
    queryKey: ["workspace", auth.userId],
    enabled: !!(auth.hasToken && auth.userId),
    refetchInterval: false,
  });

  return (
    <AsyncResult query={ownWorkspace}>
      {(workspace) => (
        <WorkspaceContext.Provider value={workspace}>
          {children}
        </WorkspaceContext.Provider>
      )}
    </AsyncResult>
  );
}
